import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import {
  getFromColorMap,
  isThemeColor,
} from '@wix/thunderbolt-commons/dist/color';
import type { CompInfo } from '@wix/thunderbolt-components-native';

import type {
  TextEffectsSharedDefinition,
  TextEffectsSharedMapperProps,
} from '../TextEffectsShared.types';
import {
  castFromInheritIfNeeded,
  isValidHexaOrHex,
} from '@wix/editor-elements-common-utils';

const resolveColor =
  (siteColors: CompInfo['siteColors']) =>
  (color?: string): string | undefined => {
    if (!color) {
      return undefined;
    }
    return isThemeColor(color) ? getFromColorMap(color, siteColors) : color;
  };

export const props = withCompInfo<
  TextEffectsSharedMapperProps,
  TextEffectsSharedDefinition
>()(
  ['compData', 'language', 'directionWithOptInRtlSupport', 'isInSeo'],
  ({ compData, language, directionWithOptInRtlSupport, isInSeo }) => {
    const textDirection = castFromInheritIfNeeded(
      compData?.textDirection ?? 'inherit',
      directionWithOptInRtlSupport,
    );
    return {
      ...compData,
      patternScope: isInSeo ? 'none' : compData?.patternScope,
      language,
      textDirection,
    };
  },
);

export const css = withCompInfo()(
  ['styleProperties', 'siteColors'],
  ({ styleProperties, siteColors }) => {
    const getResolvedColor = resolveColor(siteColors);

    const colorVars: Record<string, string | undefined> = {};
    for (const [key, value] of Object.entries(styleProperties)) {
      if (typeof value === 'string') {
        const resolvedColor = getResolvedColor(value);
        if (resolvedColor && isValidHexaOrHex(resolvedColor)) {
          colorVars[`--${key}`] = resolvedColor;
        }
      }
    }

    return colorVars;
  },
);

export const stateRefs = withStateRefsValues(['reducedMotion', 'experiments']);

export default createComponentMapperModel({
  props,
  css,
  stateRefs,
});
